import { useEffect, useState, useRef, useCallback } from "react";
import { WidgetConfigProvider, RemoteWidget } from "@tiktokshop/widget-kit-react";

export default function App() {
    const [tokenData, setTokenData] = useState(null);
    const refreshTimer = useRef(null);

    // Hàm fetch token từ backend
    const fetchToken = useCallback(async () => {
        try {
            const res = await fetch("/api/website/widget", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    outer_shop_id: "xxx",
                    partner_type: "1",
                }),
            });

            const data = await res.json();
            const widgetToken = data?.data?.widget_token; // ✅ lấy đúng object widget_token

            if (widgetToken?.token && widgetToken?.expire_at) {
                setTokenData(widgetToken);

                // Clear timer cũ nếu có
                if (refreshTimer.current) clearTimeout(refreshTimer.current);

                // Tính TTL (expire_at là UNIX giây → convert sang ms)
                const now = Math.floor(Date.now() / 1000);
                const ttl = widgetToken.expire_at - now;

                // Refresh trước 1 phút khi token gần hết hạn
                if (ttl > 60) {
                    refreshTimer.current = setTimeout(fetchToken, (ttl - 60) * 1000);
                }
            }
        } catch (err) {
            console.error("Fetch token failed:", err);
        }
    }, []);

    // Gọi 1 lần duy nhất khi mount
    useEffect(() => {
        fetchToken();
        return () => {
            if (refreshTimer.current) clearTimeout(refreshTimer.current);
        };
    }, [fetchToken]);

    // Hàm getToken: SDK sẽ gọi, mình chỉ return token đã cache
    const getToken = async () => {
        if (!tokenData) return {};
        return tokenData; // ✅ trả về đúng object { token, expire_at }
    };

    if (!tokenData) {
        return <div>Loading widget...</div>;
    }

    return (
        <WidgetConfigProvider
            config={{
                shopId: "7496266380651629434",
                oecRegion: "US",
                appKey: "6em06b82qg1hk",
                isvInfo: { name: "OPEN_PLATFORM" },
            }}
            getToken={getToken}
            remotes={[{ name: "@tiktokshop-widget/logistics:warehouse" }]}
            preloadWidgetNames={["@tiktokshop-widget/logistics:warehouse"]}
        >
            <RemoteWidget
                name="@tiktokshop-widget/logistics:warehouse"
                className="containerClass"
                options={{
                    type: "management",
                    onResult: (data) => {
                        if (data.code === 0) {
                            console.log("Warehouse submit success");
                        }
                    },
                }}
            />
        </WidgetConfigProvider>
    );
}
